<template lang="es">
    <div>
        <v-dialog
            v-model="k"
            persistent
        >
        <v-card>
            <v-card-title class="text-h5">
                {{dialogTitle}}
            </v-card-title>
            <v-card-text>
              <line-chart 
              v-if="datos_grafico.labels"
                :chart-data="data_a_mostrar"
            ></line-chart>
            </v-card-text>
            <v-btn @click="cerrar()" icon class="close-btn">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-card>
    </v-dialog>
</div>
  

</template>

<script>
import LineChart from "@/components/modulos/LineChart";
export default {
  components: {
    LineChart,
  },
  props: {
    datos_grafico: Object,
    dialogTitle: String,
    mostrar: Boolean,
  },
  data() {
    return {
      k: false,
    };
  },

  computed: {
    data_a_mostrar() {
      return this.datos_grafico;
    },
  },

  watch: {
    mostrar(val) {
      this.k = val;
    },
  },

  methods: {
    cerrar() {
      this.$emit("cerrar");
    },
  },
};
</script>
<style>
.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  border-radius: 50%;
  background-color: transparent;
}
</style>
